// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Account-__practice-locations__wrapper--1t667"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Account/practice-locations.css
// module id = 1961
// module chunks = 0